module.exports = __webpack_public_path__ + "img/bottle_return.eb5b3529.png";